let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("22apG")).then(() => parcelRequire('6J86O'));